import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const PlanLeftSectionTilesWrapper = styled.div`
  background: ${themeGet('colors.white')};
  display: ${({ active }) => (active ? 'flex' : 'none')};
  flex-wrap: wrap;
  padding: 16px 8px 16px 24px;
  overflow: auto;
  place-content: flex-start;

  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 0px 8px 8px 8px;

  @media screen and (max-width: 800px) {
    justify-content: center;
  }
`;
